import { ChevronLeft, FullscreenRounded, MenuOpenRounded, MenuRounded, NotificationsRounded } from '@mui/icons-material'
import { Avatar, Badge, Box, Button, ButtonBase, Divider, IconButton, List, ListItemButton, ListSubheader, Stack, Tooltip, Typography } from '@mui/material'
import grey from '@mui/material/colors/grey'
import { MouseEvent, useState } from 'react'
import Flags from 'react-country-flag'
import Loading from 'react-loading'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import signout from '../../../api/auth/signout'
import { appActions, selectSideMenuState } from '../../../store/features/app'
import { currentAdminShopActions, selectCurrrentAdminShop } from '../../../store/features/currentBusinessShop'
import { RootState } from '../../../store/store'
import { CustomMenu } from '../../molecules'
import InternationalizationModal from './modals/InternationalizationModal'
import NotificationsModal from './modals/NotificationsModal'


export default function DashboardContent({children}:{children:JSX.Element|JSX.Element[]}) {

    const availableShops = useSelector((state:RootState)=>state.currentBusiness.shops)
    const currentShop = useSelector(selectCurrrentAdminShop)

    const [isSigningOut, setIsSigningOut] = useState(false)

    const dispatch = useDispatch()
    const history = useHistory()

    const [i118nModalVisibility, setI118nModalVisibility] = useState(false)
    const [notificationsModalVisibility, setNotificationsModalVisibility] = useState(false)
    const sideMenuState = useSelector(selectSideMenuState)

    const [btnCreateAnchorEl, setBtnCreateAnchorEl] = useState<HTMLAnchorElement|HTMLButtonElement|null>(null)
    const [btnProfileSettingsAnchorEl, setBtnProfileSettingsAnchorEl] = useState<HTMLAnchorElement|HTMLButtonElement|null>(null)
    const btnCreateIsOpen = Boolean(btnCreateAnchorEl)

    
    const [btnNotificationsAnchorEl, setBtnNotificationsAnchorEl] = useState(null)
    const btnNotificationsIsOpen = Boolean(btnNotificationsAnchorEl)
    const btnProfileSettingsIsOpen = Boolean(btnProfileSettingsAnchorEl)

    const handleBtnCreateOnClick = (e:MouseEvent<HTMLAnchorElement|HTMLButtonElement>)=>setBtnCreateAnchorEl(e.currentTarget)
    const handleBtn118nOnClick = ()=>setI118nModalVisibility(i118nModalVisibility === true ? false : true)
    const handleBtnNotificationsOnClick = (e:MouseEvent<HTMLAnchorElement|HTMLButtonElement>)=>setNotificationsModalVisibility(notificationsModalVisibility === true ? false : true)
    const handleBtnMenuOnClick = ()=>dispatch(appActions.toggleSideMenuState())
    const handleBtnProfileSettingsOnClick = (e:MouseEvent<HTMLAnchorElement|HTMLButtonElement>)=>setBtnProfileSettingsAnchorEl(e.currentTarget)
    
    const handleBtnCreateOnClose = ()=>setBtnCreateAnchorEl(null)
    const handleBtnProfileSettingsOnClose = ()=>setBtnProfileSettingsAnchorEl(null)
    const handleBtnNotificationsOnClose = ()=>setBtnNotificationsAnchorEl(null)
    const handleFullScreenOnClick = ()=>dispatch(appActions.toggleFullscreenMode())


    const handleOnSignOut = async()=>{

        try {

            setIsSigningOut(true)
    
            await signout()
            setIsSigningOut(false)


        } catch (error) {
            setIsSigningOut(false)
        }
        
    }


    return (
        <Box 
            sx={{
                flex: 5,
                display: "flex",
                flexDirection: "column",
            }}
        >
            <InternationalizationModal visible={i118nModalVisibility} setVisibility={handleBtn118nOnClick} />
            <NotificationsModal visible={notificationsModalVisibility} setVisibility={handleBtnNotificationsOnClick} />

            <Box
                sx={{
                    flex:1,
                    width: "100%",
                    backgroundColor: "primary.light",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingX: "1.5rem",
                }}
            >
                <Stack direction="row" spacing={1} >
                    <Tooltip title={sideMenuState === "full" ? "Close menu" : "Open menu"}>
                        <IconButton sx={styles.button} onClick={handleBtnMenuOnClick} >
                            {sideMenuState === "full" ? <MenuOpenRounded sx={styles.icon} />  : <MenuRounded sx={styles.icon} />} 
                        </IconButton>
                    </Tooltip>

                    <Stack >
                        <Button onClick={handleBtnCreateOnClick} variant="contained" disableElevation sx={{paddingX: ".8rem", paddingY: ".2rem", color: grey[200], height: "100%"}}  >
                            <Typography sx={{textTransform: "capitalize", fontSize: "14px", marginRight: ".3rem" }} >Create</Typography> 
                            <ChevronLeft sx={{fontSize: "16px", transform: "rotate(-90deg)"}} />
                        </Button>
                        <CustomMenu
                            anchorEl={btnCreateAnchorEl}
                            open={btnCreateIsOpen}
                            onClose={handleBtnCreateOnClose}
                        >
                            <List>

                                <ListItemButton> <Typography sx={{color: grey[200], fontSize: "13px"}} >New Shop</Typography> </ListItemButton>
                                <ListItemButton> <Typography sx={{color: grey[200], fontSize: "13px"}} >New Warehouse</Typography> </ListItemButton>
                                <ListItemButton> <Typography sx={{color: grey[200], fontSize: "13px"}} >New User</Typography> </ListItemButton>

                            </List>
        
                        </CustomMenu>
                    </Stack>

                </Stack>

                <Stack direction="row" spacing={1} >

                    <Stack>
                        <Tooltip title="Language">
                            <IconButton onClick={handleBtn118nOnClick} sx={styles.button}>
                                <Flags countryCode="US" svg  />
                            </IconButton>
                        </Tooltip>
                    </Stack>


                    <Tooltip title="Fullscreen">
                        <IconButton sx={styles.button} onClick={handleFullScreenOnClick} >
                            <FullscreenRounded sx={styles.icon} />
                        </IconButton>
                    </Tooltip>
                    <Stack>
                        <Tooltip title="Notifications">
                            <IconButton sx={styles.button} onClick={handleBtnNotificationsOnClick} >
                                <Badge badgeContent={4} color="warning">
                                    <NotificationsRounded sx={styles.icon} />
                                </Badge>
                            </IconButton>
                        </Tooltip>
                        <CustomMenu
                            open={btnNotificationsIsOpen}
                            anchorEl={btnNotificationsAnchorEl}
                            onClose={handleBtnNotificationsOnClose}
                        >
                            <List sx={{border: `.5px solid rgba(255, 255, 255, 0.1)`}}>
                                <ListItemButton > <Typography variant="h6" sx={{color: grey[200], fontSize: "15px"}} >{`Notifications(2)`}</Typography> </ListItemButton>
                                <Divider />
                                <ListItemButton selected={true} > <Typography sx={{color: grey[200], fontSize: "13px"}} >Restock Shop A</Typography> </ListItemButton>
                                <ListItemButton> <Typography sx={{color: grey[200], fontSize: "13px"}} >Restock Shop B</Typography> </ListItemButton>
                            </List>
                        </CustomMenu>
                    </Stack>

                    <Stack>
                        <Tooltip title="Profile settings">
                            <ButtonBase
                                onClick={handleBtnProfileSettingsOnClick}
                                sx={{
                                    borderRadius: "100%"
                                }}
                            >
                                <Avatar 
                                    alt="avatar"
                                    src='./img/dp.jpg'
                                    sx={{width: "32px", height: "32px"}}
                                />
                            </ButtonBase>
                        </Tooltip>
                        <CustomMenu
                            open={btnProfileSettingsIsOpen}
                            anchorEl={btnProfileSettingsAnchorEl}
                            onClose={handleBtnProfileSettingsOnClose}
                        >
                            <List 
                                subheader={<ListSubheader sx={{backgroundColor: "primary.dark", color: "grey.200"}}>Shops</ListSubheader>}
                            >
                                
                                <Box
                                    sx={{maxHeight:"5rem", overflow: "auto"}}
                                >
                                    {
                                        availableShops
                                        ?.map((shop, index)=>(
                                            
                                            <ListItemButton
                                                key={index}
                                                onClick={()=>{
                                                    dispatch(currentAdminShopActions.setCurrentAdminShop(shop))
                                                    history.push(`/${shop?.name}`)
                                                }}
                                            > 
                                                <Box
                                                    sx={{padding: "0rem .5rem", display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center"}}
                                                >
                                                    <Typography sx={{color: grey[200], fontSize: "13px", textAlign: "center"}} >{shop.name}</Typography>
                                                    {
                                                        shop?.name === currentShop?.name && <span className="w-2 h-2 bg-blue-600 inline-block rounded-full"/>
                                                    }
                                                </Box>
                                                
                                            </ListItemButton>
                                        ))
                                    }
                                </Box>
                                {/* <Divider /> */}
                            </List>
                            <List
                                subheader={<ListSubheader sx={{backgroundColor: "primary.dark", color: "grey.200"}}>Extra</ListSubheader>}
                            >
                                <ListItemButton
                                    onClick={()=>{
                                        dispatch(currentAdminShopActions.clearCurrentAdminShop())
                                        history.push('/')
                                    }}
                                    > 
                                    <Box
                                        sx={{padding: "0rem 0.5rem"}}
                                    >
                                        <Typography sx={{color: grey[200], fontSize: "13px", textAlign: "center"}} >Goto main portal</Typography>
                                    </Box>
                                </ListItemButton>
                                <ListItemButton
                                    onClick={handleOnSignOut}
                                > 
                                    <Box
                                        sx={{padding: "0rem .5rem"}}
                                    >

                                        {
                                            isSigningOut ? (
                                                <Loading 
                                                    color='#E8E8E8'
                                                    type='spin'
                                                    width={16}
                                                    height={16}
                                                />
                                            ): (
                                                <Typography sx={{color: grey[200], fontSize: "13px"}} >Sign out</Typography> 
                                            )
                                        }
                                        
                                    </Box>
                                </ListItemButton>
                            </List>
                        </CustomMenu>
                    </Stack>

                </Stack>  
            </Box>
            <Box
                sx={{
                    flex:10,
                    width: "100%",
                    backgroundColor: "primary.dark",
                    padding: "2rem",
                    overflowY: "scroll",
                    height: "100%"
                }}
            >

                {children}

            </Box>

        </Box>
    )
}



const styles ={

    icon: {
        color: grey[200],
    },
    button:{
        padding: "0.5rem",
        borderRadius: "100%"
    }

}